var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4"},[_c('v-card-text',{staticStyle:{"max-height":"500px","background-color":"white"}},[(_vm.loading)?_c('v-container',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_c('bar-chart',{attrs:{"chart-data":_vm.dataCollection,"chart-options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }